// posible positions of the anchored plugin position
export const ANCHORED_PLUGIN_POSITIONS = {
    TOP_LEFT: "TOP_LEFT",
    BOTTOM_LEFT: "BOTTOM_LEFT",
    CENTER_LEFT: "CENTER_LEFT",
    TOP_CENTER: "TOP_CENTER",
    CENTER_CENTER: "CENTER_CENTER",
    BOTTOM_CENTER: "BOTTOM_CENTER",
    TOP_RIGHT: "TOP_RIGHT",
    CENTER_RIGHT: "CENTER_RIGHT",
    BOTTOM_RIGHT: "BOTTOM_RIGHT"
};
